function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: 40,
  cy: 40,
  r: 40,
  fill: "#000",
  fillOpacity: 0.04
}), React.createElement("g", {
  transform: "translate(17 15)"
}, React.createElement("path", {
  fill: "#9E9E9E",
  d: "M35.908 19.811H34.67v-4.953C34.67 6.665 28.005 0 19.81 0 11.618 0 4.953 6.665 4.953 14.858v4.953H3.715A3.718 3.718 0 0 0 0 23.526V40.86a3.718 3.718 0 0 0 3.715 3.714h32.193a3.718 3.718 0 0 0 3.715-3.714V23.526a3.719 3.719 0 0 0-3.715-3.715zM7.429 14.858c0-6.827 5.555-12.382 12.382-12.382 6.828 0 12.382 5.555 12.382 12.382v4.953h-2.476v-4.953c0-5.461-4.444-9.905-9.906-9.905-5.461 0-9.905 4.444-9.905 9.905v4.953H7.429v-4.953zm19.812 0v4.953H12.382v-4.953c0-4.095 3.334-7.429 7.43-7.429 4.095 0 7.429 3.334 7.429 7.43zm9.905 26.003c0 .683-.555 1.238-1.238 1.238H3.715a1.24 1.24 0 0 1-1.239-1.238V23.526a1.24 1.24 0 0 1 1.239-1.238h32.193c.683 0 1.238.555 1.238 1.238V40.86z"
}), React.createElement("circle", {
  cx: 37.5,
  cy: 18.349,
  r: 10.236,
  fill: "#F5F5F5"
}), React.createElement("g", {
  fill: "#9E9E9E"
}, React.createElement("path", {
  d: "M42.128 13.826l-6.083 6.378-3.307-2.904a.889.889 0 1 0-1.165 1.345l3.942 3.458a.89.89 0 0 0 1.229-.054l6.682-6.996a.887.887 0 0 0-.014-1.273.888.888 0 0 0-1.272.046h-.012z"
}), React.createElement("path", {
  d: "M37.5 6.792a11.556 11.556 0 1 0 0 23.113 11.556 11.556 0 0 0 0-23.113zm0 21.335a9.78 9.78 0 1 1 6.915-16.693A9.78 9.78 0 0 1 37.5 28.127z"
}))));

var SvgVerifyLock = function SvgVerifyLock(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    width: 80,
    height: 80
  }, props), React.createElement("title", null, title), _ref2);
};

export default SvgVerifyLock;